import { IAppEvent } from "../../Event";
import { IScanner } from "./IScanner";

export interface ICameraScannerCapabilities {
    flash: boolean;
    focus: boolean;
}

export interface ICameraScanner extends IScanner {

    updateFlashAsync(isOn: boolean): Promise<boolean>;

    setCameraAsync(index: number): Promise<void>;

    switchCameraAsync(): Promise<void>;

    updateFocusAsync(focus: number): Promise<boolean>;

    getCapabilities(): ICameraScannerCapabilities;

    getVideo(): HTMLVideoElement;

    readonly isFlashOn: boolean;

    readonly focus: number;

    readonly cameras: MediaDeviceInfo[];

    readonly activeCamera: number;

    readonly onScannerReady: IAppEvent<void>;
}

export function isCameraScanner(obj: any): obj is ICameraScanner {
    return obj && typeof obj == "object" && "setCameraAsync" in obj;
}